/**
 * Quiz option subtext: shows the learner's L1 gloss (e.g. "りんご") under each
 * MultipleChoice / ListeningFirst / MixedChallenge option to scaffold reading
 * comprehension at A1/A2/B1.
 *
 * Rule:
 *   A1, A2         → always show (forced — learners can't parse long defs yet)
 *   B1             → respect showL1QuizTranslations toggle (default on)
 *   B2, C1, C2, …  → never show (English-only by the time learners reach B2)
 *
 * Reading is intentionally omitted — quiz options are scan-fast surfaces and
 * the meaning alone is the comprehension scaffold. The reading lives on the
 * flashcard back where there's room to study it.
 */
import type { Card } from '@kevvykevwin/lang-core/types';
import { signals } from '../srs.js';
import { learnerLanguage, showL1QuizTranslations } from '../i18n/learner.js';
import type { EnglishCardExt } from '../types.js';

export function quizL1Subtext(card: Card<EnglishCardExt>): string | undefined {
  const level = signals.currentLevel.value;
  if (level !== 'A1' && level !== 'A2' && level !== 'B1') return undefined;
  if (level === 'B1' && !showL1QuizTranslations.value) return undefined;
  return card.wordTranslations?.[learnerLanguage.value]?.meaning;
}
